import { Button, Flex, Space, Typography } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import AntIcon from "../../../../../../common/components/icons/AntIcon";

type Props = {
  onClick: () => void;
};

export const AddGoalCard = ({ onClick }: Props) => {
  const { t } = useTranslation();

  const [hovered, setHovered] = useState(false);

  return (
    <Flex
      vertical
      align="center"
      style={{
        backgroundColor: hovered ? "white" : "#e8e8e8",
        height: "100%",
        borderRadius: 18,
        border: "1px solid #e1e1e1",
        cursor: hovered ? "pointer" : "default",
      }}
      justify="center"
      onMouseOver={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onClick={onClick}
    >
      <Space orientation="vertical" align="center">
        <Button
          shape="circle"
          type="dashed"
          size="large"
          icon={<AntIcon color={hovered ? undefined : "grey"} type="plus" />}
        />
        <Typography.Title level={3} type={hovered ? undefined : "secondary"}>
          {t("dashboard.goals.titles.addGoal")}
        </Typography.Title>
      </Space>
    </Flex>
  );
};
